var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('h2',[_vm._v(" "+_vm._s(_vm.cardData.h2)+" ")]),_c('div',[_c('ul',_vm._l((_vm.cardData.data),function(value,key,index){return _c('li',{key:index},[_c('p',[_vm._v(_vm._s(value))]),_c('p',[_vm._v(_vm._s(_vm.keyFilters[key]))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }